import React, { useEffect, useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";

import '../css/gallerySlide.css';

import defaultImage from '../images/empty_box.png';
import kavitaImage from "../images/kavita.jpg";
import dashehraImage from "../images/dashehra.jpg";
import tripImage from "../images/trip.jpg";
import hindiDivasImage from "../images/hindidivas.jpg";
import sportsImage from "../images/sport.jpg";
import innovationImage from "../images/innovation.jpg";
import { removeGalleryImageSvc, saveGalleryPhotoSvc } from "../slidesSvc";

function GallerySlideComponent(props) {
    const { ptmdId = 0, flgEditPlay = "edit", basePathPtmGallery, lstPtmGallery } = props;

    const imgPath = "https://www.sms.cooledsys.com:8280/sms/gallery/docs/view?imgPath=";
    const emptyImgPath = window.appURL + "/no-image.png";

    // Separate state for each image
    const [galleryImg1, setGalleryImg1] = useState(null);
    const [galleryImg2, setGalleryImg2] = useState(null);
    const [galleryImg3, setGalleryImg3] = useState(null);
    const [galleryImg4, setGalleryImg4] = useState(null);
    const [galleryImg5, setGalleryImg5] = useState(null);

    const [basePath, setBasePath] = useState("");
    // Separate refs for each image input
    const galleryImg1InputRef = useRef(null);
    const galleryImg2InputRef = useRef(null);
    const galleryImg3InputRef = useRef(null);
    const galleryImg4InputRef = useRef(null);
    const galleryImg5InputRef = useRef(null);

    useEffect(() => {
        // console.log("GallerySlidecomponent called, flgEditPlay", flgEditPlay, ", lstPtmGallery", lstPtmGallery, ", basePathPtmGallery", basePathPtmGallery);
        if (!!lstPtmGallery) {
            setGalleryImg1(findPhotoByImageNo(1, lstPtmGallery, basePathPtmGallery));
            setGalleryImg2(findPhotoByImageNo(2, lstPtmGallery, basePathPtmGallery));
            setGalleryImg3(findPhotoByImageNo(3, lstPtmGallery, basePathPtmGallery));
            setGalleryImg4(findPhotoByImageNo(4, lstPtmGallery, basePathPtmGallery));
            setGalleryImg5(findPhotoByImageNo(5, lstPtmGallery, basePathPtmGallery));
        }
        setBasePath(`https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${basePathPtmGallery}`);
    }, [basePathPtmGallery, lstPtmGallery]);

    const findPhotoByImageNo = (pImgNo, pLstPtmGallery, pBasePathPtmGallery) => {
        const tempBasePath = `https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${pBasePathPtmGallery}`;
        // console.log('findgalleryByRank called, pImgNo', pImgNo, ', pLstPtmGallery', pLstPtmGallery, ", pBasePathPtmGallery", pBasePathPtmGallery);
        if (!Array.isArray(pLstPtmGallery)) {
            console.error("Error: pLstPtmGallery is not an array", pLstPtmGallery);
            return null;
        }
        const galleryFound = pLstPtmGallery.find(gallery => gallery.imgNo === pImgNo) || null;
        if (galleryFound?.fileName) {
            fetch(tempBasePath + "/" + galleryFound.fileName)
                .then(response => response.blob())
                .then(blob => {
                    const file = new File([blob], imgPath.split('/').pop(), { type: blob.type });
                    galleryFound.photo = file;
                })
                .catch(error => {
                    console.error("Error fetching the image Inside findPhotoByImageNo:", error);
                    galleryFound.photo = null;
                });
        }
        // console.log("galleryFound", galleryFound);
        return galleryFound;
    };

    const handleImageUpload = (e, setImageState, pImgNo) => {
        if (flgEditPlay !== "edit") {
            return;
        }
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];

            // Create a local preview of the image
            const fileUrl = URL.createObjectURL(file);
            const fileName = file.name;

            // Update the state with the file preview and file data
            setImageState({ fileName: fileUrl, file });

            // Prepare the gallery data
            const ptmGallery = {
                ptmId: ptmdId,
                imgNo: pImgNo,
                fileName: fileName || ""
            };

            // Call the service to save the gallery photo
            saveGalleryPhotoSvc(ptmGallery, file, saveGalleryResponse);
        }
    };


    const saveGalleryResponse = (data) => {
        // console.log("saveGalleryResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
    }

    const handleRemovePhoto = (pImgNo) => {
        // console.log("handleRemovePhoto called, pImgNo", pImgNo);
        removeGalleryImageSvc(ptmdId, pImgNo, removeGalleryImageResponse);
    }

    const removeGalleryImageResponse = (data) => {
        // console.log("removeGalleryImageResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            props.updateKey();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
    }

    const handleImageError = (setImageState) => {
        const resetData = { fileName: emptyImgPath, photo: null };
        setImageState(resetData);
    };


    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };


    return (
        <div className="main-component " >
            <div className=" landscape-section" >
                <div className="top-block" style={{ position: 'relative' }}>
                    {galleryImg1 && galleryImg1.fileName ? (
                        <img
                            src={galleryImg1.fileName.startsWith("blob:")
                                ? galleryImg1.fileName
                                : `${basePath}/${galleryImg1.fileName}`}
                            alt="Image1"
                            className="gallery-image"
                            onError={() => handleImageError(setGalleryImg1)}
                            onClick={() => galleryImg1InputRef.current.click()} // Trigger file input click
                        />
                    ) : (
                        <img
                            src={hindiDivasImage}
                            alt="Empty"
                            className="gallery-image"
                            onClick={() => galleryImg1InputRef.current.click()} // Trigger file input click
                        />
                    )}
                    <input
                        type="file"
                        ref={galleryImg1InputRef}
                        className="hidden"
                        onChange={(e) => handleImageUpload(e, setGalleryImg1, 1)}
                        accept="image/*"
                        disabled={flgEditPlay !== "edit"}
                    />
                    {flgEditPlay === "edit" ? (
                        <span
                            id="removeGalleryImg1"
                            title="Remove Image"
                            className="glyphicon glyphicon-remove"
                            style={{
                                color: "red",
                                position: "absolute",  // Absolute positioning to move it to top-right
                                top: "10px",            // Distance from the top
                                right: "10px",          // Distance from the right
                                fontSize: "large"
                            }}
                            onClick={() => handleRemovePhoto(1)}
                        ></span>
                    ) : null}
                </div>
                <div className="  bottom-block " style={{ position: 'relative' }} >
                    {galleryImg4 && galleryImg4.fileName ? (
                        <img
                            src={galleryImg4.fileName.startsWith("blob:")
                                ? galleryImg4.fileName
                                : `${basePath}/${galleryImg4.fileName}`}
                            alt="Image4"
                            className="gallery-image"
                            onError={() => handleImageError(setGalleryImg4)}
                            onClick={() => galleryImg4InputRef.current.click()} // Trigger file input click
                        />
                    ) : (
                        <img
                            src={innovationImage}
                            alt="Empty"
                            className="gallery-image"
                            onClick={() => galleryImg4InputRef.current.click()} // Trigger file input click
                        />
                    )}
                    <input
                        type="file"
                        ref={galleryImg4InputRef}
                        className="hidden"
                        onChange={(e) => handleImageUpload(e, setGalleryImg4, 4)}
                        accept="image/*"
                        disabled={flgEditPlay !== "edit"}
                    />
                    {flgEditPlay === "edit" ? (
                        <span
                            id="removeGalleryImg4"
                            title="Remove Image"
                            className="glyphicon glyphicon-remove"
                            style={{
                                color: "red",
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                fontSize: "large"
                            }}
                            onClick={() => handleRemovePhoto(4)}
                        ></span>
                    ) : null}

                </div>
            </div>
            <div className=" landscape-section " >
                <div className="  top-block " style={{ position: 'relative' }}>
                    {galleryImg2 && galleryImg2.fileName ? (
                        <img
                            src={galleryImg2.fileName.startsWith("blob:")
                                ? galleryImg2.fileName
                                : `${basePath}/${galleryImg2.fileName}`}
                            alt="Image2"
                            className="gallery-image"
                            onError={() => handleImageError(setGalleryImg2)}
                            onClick={() => galleryImg2InputRef.current.click()} // Trigger file input click
                        />
                    ) : (
                        <img
                            src={tripImage}
                            alt="Empty"
                            className="gallery-image"
                            onClick={() => galleryImg2InputRef.current.click()} // Trigger file input click
                        />
                    )}
                    <input
                        type="file"
                        ref={galleryImg2InputRef}
                        className="hidden"
                        onChange={(e) => handleImageUpload(e, setGalleryImg2, 2)}
                        accept="image/*"
                        disabled={flgEditPlay !== "edit"}
                    />
                    {flgEditPlay === "edit" ? (
                        <span
                            id="removeGalleryImg2"
                            title="Remove Image"
                            className="glyphicon glyphicon-remove"
                            style={{
                                color: "red",
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                fontSize: "large"
                            }}
                            onClick={() => handleRemovePhoto(2)}
                        ></span>
                    ) : null}
                </div>
                <div className="  bottom-block " style={{ position: 'relative' }}>
                    {galleryImg5 && galleryImg5.fileName ? (
                        <img
                            src={galleryImg5.fileName.startsWith("blob:")
                                ? galleryImg5.fileName
                                : `${basePath}/${galleryImg5.fileName}`}
                            alt="Image5"
                            className="gallery-image"
                            onError={() => handleImageError(setGalleryImg5)}
                            onClick={() => galleryImg5InputRef.current.click()} // Trigger file input click
                        />
                    ) : (
                        <img
                            src={sportsImage}
                            alt="Empty"
                            className="gallery-image"
                            onClick={() => galleryImg5InputRef.current.click()} // Trigger file input click
                        />
                    )}
                    <input
                        type="file"
                        ref={galleryImg5InputRef}
                        className="hidden"
                        onChange={(e) => handleImageUpload(e, setGalleryImg5, 5)}
                        accept="image/*"
                        disabled={flgEditPlay !== "edit"}
                    />
                    {flgEditPlay === "edit" ? (
                        <span
                            id="removeGalleryImg5"
                            title="Remove Image"
                            className="glyphicon glyphicon-remove"
                            style={{
                                color: "red",
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                fontSize: "large"
                            }}
                            onClick={() => handleRemovePhoto(5)}
                        ></span>
                    ) : null}
                </div>
            </div>
            <div className=" verticle-section " style={{ position: 'relative' }} >
                {galleryImg3 && galleryImg3.fileName ? (
                    <img
                        src={galleryImg3.fileName.startsWith("blob:")
                            ? galleryImg3.fileName
                            : `${basePath}/${galleryImg3.fileName}`}
                        alt="Image3"
                        className="gallery-image"
                        onError={() => handleImageError(setGalleryImg3)}
                        onClick={() => galleryImg3InputRef.current.click()} // Trigger file input click
                    />
                ) : (
                    <img
                        src={dashehraImage}
                        alt="Empty"
                        className="gallery-image"
                        onClick={() => galleryImg3InputRef.current.click()} // Trigger file input click
                    />
                )}
                <input
                    type="file"
                    ref={galleryImg3InputRef}
                    className="hidden"
                    onChange={(e) => handleImageUpload(e, setGalleryImg3, 3)}
                    accept="image/*"
                    disabled={flgEditPlay !== "edit"}
                />
                {flgEditPlay === "edit" ? (
                    <span
                        id="removeGalleryImg3"
                        title="Remove Image"
                        className="glyphicon glyphicon-remove"
                        style={{
                            color: "red",
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            fontSize: "large"
                        }}
                        onClick={() => handleRemovePhoto(3)}
                    ></span>
                ) : null}

            </div>
        </div>
    )
}

export default GallerySlideComponent;